import template from './document_categories.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeDocumentType
{
	constructor(config)
	{
		let data = Object.assign({
			type: '',
			default_viewing_roles: ['admin'],
			edit_mode: false
		}, config);

		ko.mapping.fromJS(data, {}, this);

		this.type = ko.observable(data.type);
		this.type.subscribe((value) => {
			if (value != '')
				window.document.getElementById('warning-empty').style.display = 'none';
		});
	}
}

class AdminDocumentCategoriesViewModel
{
	constructor(page)
	{
		this.page = page;
		this.employee_document_types = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.editing = ko.observable(false);
		window.current_page_title(tr('Add/Edit Employee Document Categories'));
	}

	show_employee_documents_help()
	{
		Grape.dialog.open('EmployeeDocumentsHelp', {});
	}

	async toggle_edit_mode(data)
	{
		this.editing(!this.editing());
		if (data.edit_mode())
			await this.page.updateData(); 
		data.edit_mode(!data.edit_mode());
	}

	add_document_type()
	{
		let employee_doc_type = new EmployeeDocumentType();
		employee_doc_type.edit_mode(true);
		this.employee_document_types.unshift(employee_doc_type);
		this.editing(true);
	}

	async delete_document_type(data_)
	{
		let data = ko.mapping.toJS(data_);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this document type?')});
		// Remove custom fields
		delete data.edit_mode;
		
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/employee_document_types/delete', data);
			if (res.status != 'ERROR')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted document type.'), title: tr('Success')});
				await this.page.updateData()
			};
		}
	}

	async save_document_type(data_)
	{
		let data = ko.mapping.toJS(data_);

		if (data.type === '')
			window.document.getElementById('warning-empty').style.display = 'block';
		else
		{
			window.document.getElementById('warning-empty').style.display = 'none';
			delete data.edit_mode;

			if (data.employee_document_type_id === '')
				data.employee_document_type_id = null;

			if (data.employee_document_type_id == null)
			{
				let res = await Grape.fetches.postJSON('/admin/employee_document_types/edit', data);
				Utils.wrap_api_result(res, tr, () => {
					Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully saved document type.')});
					this.page.updateData();
				});
			} 
			else
			{
				let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Do you want to bulk update the roles for this document type? Doing that will update the viewing roles of the documents that are already uploaded under this category.')});
				
				if (response)
				{
					data.bulk_update_viewing_roles = true;
					let res = await Grape.fetches.postJSON('/admin/employee_document_types/edit', data);
					Utils.wrap_api_result(res, tr, () => {
						Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully edited document type.')});
						this.page.updateData();
					});
				}
			}
		}
	}
}

class AdminDocumentCategoriesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminDocumentCategoriesViewModel(this);
	}

	async init()
	{
		document.title = tr('Manage Employee Document Categories');
		this.viewModel.access_roles(await Grape.cache.get('AccessRoleLookup') || []);

		// TODO: Confirm is this necessary?
		// Specific role exclusions
		this.viewModel.access_roles.remove('unverified user');
	}

	async updateData()
	{
		Grape.cache.invalidate('EmployeeDocumentTypeLookup');

		// Populate observable array
		let edt = await Grape.cache.get('EmployeeDocumentTypeLookup') || [];
		edt = edt.map((e) => { return new EmployeeDocumentType(e); });
		this.viewModel.employee_document_types(edt);

		this.viewModel.editing(false);
		Utils.refresh_data_visible_roles();
	}
}

export default {
	route: '[/]admin/document_categories',
	page_class: AdminDocumentCategoriesPage,
	template: template,
	template_filename: 'translation/document_categories'
};
